import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckIcon, XIcon } from "lucide-react";
import { purchases } from "../data/purchases";
type Notification = {
  name: string;
  country: string;
  minutes: number;
  key: number;
};
export function PurchasePopup() {
  const [current, setCurrent] = useState<Notification | null>(null);
  useEffect(() => {
    let index = Math.floor(Math.random() * purchases.length);
    let hideTimer = 0;
    let nextTimer = 0;
    const show = () => {
      const p = purchases[index % purchases.length];
      index += 1 + Math.floor(Math.random() * 3);
      setCurrent({
        ...p,
        minutes: 1 + Math.floor(Math.random() * 9),
        key: Date.now()
      });
      hideTimer = window.setTimeout(() => setCurrent(null), 5000);
      nextTimer = window.setTimeout(show, 14000);
    };
    const firstTimer = window.setTimeout(show, 6000);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, []);
  return <div className="pointer-events-none fixed inset-x-3 top-3 z-50 sm:inset-x-auto sm:bottom-6 sm:left-6 sm:top-auto" aria-live="polite" data-id="element-43" data-mp="163mo17mfhyy7">
      <AnimatePresence data-id="element-44" data-mp="1fw2604xq6nj3">
        {current && <motion.div key={current.key} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_-8px_rgba(19,35,63,0.35)] ring-1 ring-navy/10 sm:w-[340px]" data-id="element-45" data-mp="1fxvapeos2xog">
            <span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-wine font-serif text-lg font-bold text-white" data-id="element-46" data-mp="s8asiy0g84g8">
              {current.name.charAt(0)}
              <span className="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-cta ring-2 ring-white" data-id="element-47" data-mp="23l3ko9x5iuwt">
                <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-48" data-mp="2fn4taloly1zb" />
              </span>
            </span>
            <div className="min-w-0 text-sm leading-snug" data-id="element-49" data-mp="2ko29wttyynyp">
              <p className="text-navy" data-id="element-50" data-mp="2plk9htm3jqu1">
                <strong data-id="element-51" data-mp="2pkivbg9sao83">{current.name}</strong> from <strong data-id="element-52" data-mp="2pjhlff4i87ry">{current.country}</strong>
              </p>
              <p className="text-muted" data-id="element-53" data-mp="1rzmz6jhvert6">just purchased the Interceptive Orthodontics Blueprint™</p>
              <p className="mt-0.5 text-xs font-semibold text-cta" data-id="element-54" data-mp="1wxoectc6e6zd">{current.minutes} min ago · Verified purchase</p>
            </div>
            <button type="button" onClick={() => setCurrent(null)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-md p-1 text-muted hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-wine" data-id="element-55" data-mp="21uexxqn6vkpj">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-56" data-mp="3rgooxullq59e" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}